/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 23:09:58
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-01 14:52:43
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

async function checkIsAttentionWx (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _checkIsAttentionWx(id, User.res.customer).then((res) => {
          resolve(res.data.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    })
  })
}

/**
 * 检查用户是否关注微信公众号
 */
function _checkIsAttentionWx (id, customer) {
  const url = `/v1/front/subscribe`
  return axios({
    method: 'GET',
    url: url
  })
}

export {checkIsAttentionWx}



// WEBPACK FOOTER //
// ./src/api/checkIsAttentionWx.js